export default __webpack_public_path__ + "static/walls-description-image-a63ce17756b57f34c2680a20d4db2e44.svg";